/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smart_SelectInputs */



/**
* | output |
* | --- |
* | "Smart Select" |
*
* @param {Smart_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const smart_select = /** @type {((inputs?: Smart_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smart_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection intelligente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Smart Select")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione intelligente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Smart Select")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección inteligente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("智能选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スマートセレクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्मार्ट सेलेक्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção Inteligente")
	return /** @type {LocalizedString} */ ("Smart Select")
});